/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors, timings } from "../../theme";
import { ReactComponent as Cancel } from "./cancel.svg";

const RemoveButton = ({ onClick, children, disabled }) => (
    <button
        type="button"
        css={css`
            margin-right: auto;
            padding: 0;
            border: none;
            font: inherit;
            color: ${colors.neutral5};
            background-color: transparent;
            cursor: pointer;
            font-size: 16px;
            font-weight: normal;
            & > * {
                vertical-align: bottom;
            }
            & svg {
                margin-right: 5px;
            }
        `}
        onClick={disabled ? e => e.preventDefault() : onClick}
    >
        <Cancel
            css={css`
                fill: ${disabled ? colors.neutral4 : colors.neutral4};
                &:hover {
                    fill: ${colors.error4};
                }
                transition: ${timings.medium};
            `}
        />
        {children}
    </button>
);

export default RemoveButton;
